import Icon from 'components/shared/Icon/Icon';

const InfoCallout = () => (
  <div className="rounded-xl border border-solid border-primary-200 bg-primary-25 px-4 py-3">
    <div className="flex gap-3">
      <div className="mt-0.5 shrink-0" aria-hidden="true">
        <Icon icon="info-mono" size={18} color="primary" />
      </div>
      <p className="text-sm leading-relaxed text-primary-800">
        On the payment page, you have options. You can <span className="font-600">pay today</span>,{' '}
        <span className="font-600">save a card to guarantee payment</span>, or{' '}
        <span className="font-600">talk to our team</span> if you need a hand.
      </p>
    </div>
  </div>
);

export default InfoCallout;
